import { render, staticRenderFns } from "./DepartmentHeaderIcon.vue?vue&type=template&id=5801fe5d"
import script from "./DepartmentHeaderIcon.vue?vue&type=script&lang=js"
export * from "./DepartmentHeaderIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports